/* Product page helpers: review-widget fallback, colour-number search in the option dropdown,
   long option-list filter for pill pickers, and availability that follows the chosen variant. */
(() => {
  // 1) "Be the first to review" when the Yotpo star widget renders nothing
  document.querySelectorAll('[data-rating-fallback]').forEach((wrap) => {
    const widget = wrap.querySelector('.yotpo-widget-instance');
    const fallback = wrap.querySelector('.product-rating__fallback');
    if (!widget || !fallback) return;
    const check = () => { fallback.hidden = widget.childElementCount > 0 && widget.offsetHeight > 4; };
    setTimeout(check, 3500);
    new MutationObserver(check).observe(widget, { childList: true, subtree: true });
  });

  // 2) Colour codes from SKUs: ORACAL etc. put the colour number at the end of the SKU
  //    (VOR751-1510-070 → 070). Build option value → codes so search matches "070" or "black".
  const picker = document.querySelector('variant-picker');
  let productData = null;
  try { productData = JSON.parse(picker?.querySelector('script[type="application/json"]')?.textContent || 'null')?.product || null; } catch (e) { productData = null; }
  // The server-resolved picker ships no product JSON; its dropdown options carry data-code from the server.
  const codesFor = {}; // optionIndex -> { value: Set(codes) }
  if (productData && Array.isArray(productData.variants)) {
    productData.options.forEach((_, i) => { codesFor[i] = {}; });
    productData.variants.forEach((v) => {
      const sku = (v.sku || '').trim();
      const tail = sku.includes('-') ? sku.slice(sku.lastIndexOf('-') + 1) : '';
      [v.option1, v.option2, v.option3].forEach((val, i) => {
        if (!val || !codesFor[i]) return;
        const set = codesFor[i][val] || (codesFor[i][val] = new Set());
        if (sku) set.add(sku.toLowerCase());
        if (tail && /\d/.test(tail)) set.add(tail.toLowerCase());
      });
    });
  }
  const optionIndexByName = {};
  (productData?.options || []).forEach((name, i) => { optionIndexByName[String(name).toLowerCase()] = i; });
  const searchTextFor = (optionName, value) => {
    const i = optionIndexByName[String(optionName || '').toLowerCase()];
    const codes = i !== undefined ? codesFor[i]?.[value] : null;
    return [value, ...(codes ? [...codes] : [])].join(' ').toLowerCase();
  };
  const shortCodeFor = (optionName, value, el) => {
    if (el && el.dataset.code && /\d/.test(el.dataset.code) && el.dataset.code.length <= 6) return el.dataset.code.toUpperCase();
    const i = optionIndexByName[String(optionName || '').toLowerCase()];
    const codes = i !== undefined ? codesFor[i]?.[value] : null;
    if (!codes) return '';
    // shortest numeric-looking code (the colour number), not the full SKU
    return [...codes].filter((c) => c.length <= 6).sort((a, b) => a.length - b.length)[0]?.toUpperCase() || '';
  };

  // 2a) Dropdown pickers: show the colour number next to the name, and make the filter match it
  document.querySelectorAll('.option-selector[data-selector-type="dropdown"]').forEach((wrap) => {
    const optionName = (wrap.querySelector('label')?.textContent || '').replace(/[:\s]+$/, '').trim();
    const isColour = /colou?r/i.test(optionName);
    const options = wrap.querySelectorAll('.custom-select__option[data-value]');
    options.forEach((li) => {
      const value = li.dataset.value;
      li.dataset.search = [searchTextFor(optionName, value), (li.dataset.code || '').toLowerCase()].join(' ').trim();
      const code = isColour ? shortCodeFor(optionName, value, li) : '';
      if (code && !li.querySelector('.opt-code')) {
        const span = document.createElement('span');
        span.className = 'opt-code';
        span.textContent = code;
        li.appendChild(span);
      }
    });
    const search = wrap.querySelector('.custom-select__search');
    if (search) {
      search.placeholder = isColour ? 'Search by color or number…' : 'Filter…';
      const apply = () => {
        const q = search.value.trim().toLowerCase();
        options.forEach((li) => { li.hidden = !!q && !(li.dataset.search || '').includes(q); });
      };
      // run after the theme's own handler so the code-aware match wins
      search.addEventListener('input', () => setTimeout(apply, 0));
      search.addEventListener('search', () => setTimeout(apply, 0));
    }
  });

  // 2b) Pill pickers with many values: type-to-filter and "Show all"
  const SHOW = 20;
  document.querySelectorAll('fieldset[data-long-list]').forEach((fieldset) => {
    const btns = fieldset.querySelector('.option-selector__btns');
    if (!btns || fieldset.dataset.filterReady) return;
    fieldset.dataset.filterReady = 'true';
    const optionName = fieldset.dataset.optionName || 'options';
    const pairs = [];
    fieldset.querySelectorAll('input.opt-btn').forEach((input) => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (!label) return;
      const value = (label.querySelector('.js-value')?.textContent || label.textContent || input.value || '').trim();
      pairs.push({ input, label, text: searchTextFor(optionName, value) });
    });
    if (pairs.length <= SHOW) return;
    const filter = document.createElement('input');
    filter.type = 'search'; filter.className = 'input option-filter';
    filter.placeholder = `Search by ${optionName.toLowerCase()} or number…`; filter.setAttribute('aria-label', `Filter ${optionName}`);
    const toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'option-filter__toggle link text-sm';
    let expanded = false;
    const apply = () => {
      const q = filter.value.trim().toLowerCase(); let shown = 0;
      pairs.forEach((p) => { const match = !q || p.text.includes(q); const visible = match && (q || expanded || p.input.checked || shown < SHOW); if (visible) shown += 1; p.label.hidden = !visible; });
      toggle.hidden = !!q || pairs.length <= SHOW;
      toggle.textContent = expanded ? 'Show fewer' : `Show all ${pairs.length} ${optionName.toLowerCase()}s`;
    };
    toggle.addEventListener('click', () => { expanded = !expanded; apply(); });
    filter.addEventListener('input', apply);
    btns.parentNode.insertBefore(filter, btns); btns.parentNode.insertBefore(toggle, btns.nextSibling); apply();
  });

  // 3) Availability, Route and final sale follow the chosen variant (shipping block rows, route notices, final sale note, inventory line).
  // Route map comes from snippets/sw-variant-routes; it is only on the page when variants differ.
  document.addEventListener('on:variant:change', (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    const scope = (evt.target.closest && evt.target.closest('.shopify-section')) || document;
    const mapEl = scope.querySelector('[data-sw-variant-routes]');
    let route = null;
    let finalSale = null;
    if (typeof evt.detail.route === 'string') {
      route = evt.detail.route; // server-resolved picker: route comes with the variant state
      finalSale = !!evt.detail.finalSale;
    } else if (mapEl) {
      try {
        const map = JSON.parse(mapEl.textContent);
        const own = map.variants && map.variants[String(variant.id)];
        route = own !== undefined ? own : (map.default || '');
        finalSale = (map.finalSale || []).includes(String(variant.id));
      } catch (e) { route = null; }
    }
    if (finalSale !== null) {
      scope.querySelectorAll('[data-sw-final-sale]').forEach((el) => { el.hidden = !finalSale; });
    }
    scope.querySelectorAll('[data-sh-availability] [data-sh-state]').forEach((el) => {
      el.hidden = (el.dataset.shState === 'in_stock') !== !!variant.available;
    });
    if (route !== null) {
      scope.querySelectorAll('[data-sw-route-when]').forEach((el) => { el.hidden = el.dataset.swRouteWhen !== route; });
      scope.querySelectorAll('[data-sw-route-not]').forEach((el) => { el.hidden = el.dataset.swRouteNot === route; });
    }
    scope.querySelectorAll('product-inventory').forEach((inv) => {
      inv.dataset.variantAvailable = String(!!variant.available);
      if (route !== null) inv.dataset.route = route;
      if (typeof inv.render === 'function') inv.render();
    });
  });
})();
